import React, { useState } from "react";
import SimpleRenovate from "../../../assets/img/SimpleRenovate.svg";
import "./StartedScreen.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { hitLoginProfessionalApi } from "../../../Redux/Professional/LoginSlice";
import { signInWithPopup, OAuthProvider } from "firebase/auth";
import { auth2, auth, provider } from "../../../firebase";
import { hitSocialLoginGetStartedScreenProfessionalApi } from "../../../Redux/Professional/SocialMediaLoginGetStartedScreenProfessionalSlice";
import Loader from "../../Loader/Loader";
import google_icon from "../../../assets/img/devicon_google.svg";
import { initializeApp } from "firebase/app";
import axios from 'axios';

import { jwtDecode } from "jwt-decode";
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import { ClientIdGoogleLogin } from "../../../Utils/Constants";





import iphone_icon from "../../../assets/img/iphone_icon.svg";
import AppleIcon from "@mui/icons-material/Apple";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";

export default function StartedScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { setGlobalLoading } = useGlobalState();
  const [user, setUser] = useState(null);

  const [showStartedScreen, setShowStartedScreen] = useState(true);
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // simple regex
    return regex.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      let body = {};
      setLoading(true);
      setGlobalLoading(true);
      // email login
      body = { email, password };
      if (!validateEmail(email)) {
        showToast("Please enter a valid email address.", "error");
        setLoading(false);
        setGlobalLoading(false);
        return;
      }
      const res = await dispatch(hitLoginProfessionalApi(body));
      if (res.payload.status === true) {
        setLoading(false);
        setGlobalLoading(false);
        if (res.payload?.data) {
          localStorage.setItem(
            "mobileRedirectionProData",
            JSON.stringify(res.payload.data),
          );
          localStorage.setItem(
            "professionalTokenMobileRedirection",
            JSON.stringify(res.payload.data.accessToken),
          );
          showToast("Login Successful", "success");
          navigate("/manage-dashboard");
        }
      } else {
        setLoading(false);
        setGlobalLoading(false);
        showToast(res.payload.message, "error");
      }
    } catch (err) {
      setLoading(false);
      setGlobalLoading(false);
    }
  };




  // We wrap the button in a component to access the useGoogleLogin hook
  const CustomButton = () => {
    const loginG = useGoogleLogin({
      onSuccess: handleGoogleLogin,
      onError: () => console.log('Login Failed'),
      // CRITICAL: This forces the account selector and stops auto-select/hints
      prompt: 'select_account',
    });

    return (
      <div
        className="google_btn_"
        onClick={() => loginG()}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          cursor: 'pointer',
          width: '100%',     // Stays exactly 100% width
          height: '50px',    // Stays exactly the same height
          border: '1px solid #ddd',
          borderRadius: '4px',
          backgroundColor: '#fff',
          padding: '0 15px'
        }}
      >
        <img src={google_icon} alt="google icon" style={{ width: 20, height: 20 }} />
        <p style={{
          margin: 0,
          color: '#555',
          fontWeight: 500,
          fontSize: 18,
          whiteSpace: 'nowrap' // Ensures text never wraps or changes
        }}>
          Continue with Google
        </p>
      </div>
    );
  };



  const handleGoogleLogin = async (tokenResponse) => {
    try {
      // Get user info from Google API using the access token
      const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${tokenResponse.access_token}`,
        },
      });
      const details = await res.json();
      console.log("Google user info:", details);
      // Example userInfo fields: sub, name, given_name, family_name, picture, email, email_verified, locale
      // You get: details.email, details.name, details.picture, and details.sub (Numeric ID)
      // You get: details.email, details.name, details.picture, and details.sub (Numeric ID)
      let response = await dispatch(
        hitSocialLoginGetStartedScreenProfessionalApi({
          type: "Google",
          email: details.email,
          googleId: details.sub
        }),
      );
      if (response.payload.status === true) {
        setLoading(false);
        localStorage.setItem(
          "professionalTokenMobileRedirection",
          JSON.stringify(response.payload.data.accessToken),
        );
        localStorage.setItem("professionalId", JSON.stringify(response.payload.data._id));
        localStorage.setItem(
          "mobileRedirectionProData",
          JSON.stringify(response.payload.data),
        );
        showToast("Login Successful", "success");
        navigate("/manage-dashboard");
        handleViewDetails();
      } else {
        setLoading(false);
        showToast(response.payload.message, "error");
      }
    } catch (err) {
      console.error("Failed to fetch Google user info", err);
    }
  };



  const handleLogin = async () => {
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');
    try {
      const result = await signInWithPopup(auth2, provider);
      setUser(result.user);
      const credential = OAuthProvider.credentialFromResult(result);
      const idToken = credential.idToken;
      const accessToken = credential.accessToken;
      let response = await dispatch(
        hitSocialLoginGetStartedScreenProfessionalApi({
          type: "Apple",
          name: result.user.displayName,
          email: result.user.email,
          appleId: result.user.uid,
        }),
      );
      if (response.payload.status === true) {
        setLoading(false);
        setGlobalLoading(false);
        localStorage.setItem(
          "professionalTokenMobileRedirection",
          JSON.stringify(response.payload.data.accessToken),
        );
        localStorage.setItem("professionalId", JSON.stringify(response.payload.data._id));
        localStorage.setItem(
          "mobileRedirectionProData",
          JSON.stringify(response.payload.data),
        );
        showToast("Login Successful", "success");
        navigate("/manage-dashboard");
        handleViewDetails();
      } else {
        setLoading(false);
        setGlobalLoading(false);
        showToast(response.payload.message, "error");
      }
    } catch (error) {
      setLoading(false);
      setGlobalLoading(false);
      console.error("Error during Apple Sign-in:", error.code, error.message);
      if (error.code === 'auth/popup-blocked') {
        alert("Please enable popups for this website");
      }
    }
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    setGlobalLoading(true);
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    <>
      {showStartedScreen && (
        <div className="started-screen">
          {/* Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mx-auto">
              <span className="text-4xl">
                <img
                  src={SimpleRenovate}
                  alt="Simple Renovate"
                  className="navbar-logo"
                />
              </span>
            </div>
          </div>
          <br />
          {/* Heading */}
          <h1 className="started-screen__heading mb-8">
            What would you like
            <br />
            to do today?
          </h1>
          <br />

          {/* Buttons in a row */}
          <div className="started-screen__button-row w-full max-w-sm mx-auto">
            <button
              className="login-btn"
              onClick={() => setShowStartedScreen(false)}
            >
              Sign In
            </button>
            <button
              className="login-btn"
              onClick={() => setShowStartedScreen(false)}
            >
              Manage Account
            </button>
          </div>
        </div>
      )}

      {!showStartedScreen && (
        <><div className="login-form">
          {/* Logo */}
          <div className="login-form__logo mb-2">
            <img src={SimpleRenovate} alt="Logo" />
          </div>

          <p className="login-form__subtitle">
            Welcome back! Please sign in to continue
          </p>

          <div className="login-form__card">
            {/* <button className="login-form__signup">Sign up as Professional</button> */}

            <h4>Welcome Back</h4>
            <p>Login with your account by using the form below</p>

            <form onSubmit={handleSubmit}>
              <label>Email Address *</label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required />

              <label>Password *</label>
              <div className="password-input">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required />


                <div
                  style={{
                    position: "absolute",
                    right: 10,
                    top: 9,
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <VisibilityOutlinedIcon style={{ color: "#9ba3af" }} />
                  ) : (
                    <VisibilityOffOutlinedIcon style={{ color: "#9ba3af" }} />
                  )}
                </div>

              </div>

              <button
                type="submit"
                className="login-btn"
                onClick={handleViewDetails}
              >
                {" "}
                Login
              </button>
            </form>

            <div className="login-form__divider">Or sign in with</div>

            <div className="social-login social-login-signup">
   <GoogleOAuthProvider clientId={ClientIdGoogleLogin}>
                {/* Set a container with the width you want for the button */}
                <div style={{ width: '100%', maxWidth: '400px' }}>
                  <CustomButton />
                </div>
              </GoogleOAuthProvider>

              <div className="iphone_btn_" onClick={handleLogin}>
                <AppleIcon />
                <p>Sign in with Apple</p>
              </div>

            </div>

          </div>
        </div>


        </>


      )}
    </>
  );
}
